import type { RouteLocationNormalizedGeneric } from 'vue-router';

export const useCleanStoryblokPath = (to?: RouteLocationNormalizedGeneric) => {
    const route = to ?? useRoute();
    const { urlSegment } = useLanguage(to);

    const rawPath = computed(() =>
        route.path.replace(`/${urlSegment.value}`, '').replace(/^\//, '').replace(/\/$/, '')
    );

    return { rawPath };
};
